import React from "react";
import classes from "./style.module.css";
import { useDispatch, useSelector } from "react-redux";
import { JigsawPuzzle } from "react-jigsaw-puzzle/lib";
import "react-jigsaw-puzzle/lib/jigsaw-puzzle.css";
import {
  setLastQuestionId,
  setQuestionAnswered,
} from "../../../../../assets/redux/actions/Quiz";
import errorHandler from "../../../../../assets/utils/ErrorHandler";
import appApi from "../../../../../assets/utils/AppApi";

export default function Puzzle({ imgSrc, rows, cols }) {
  const dispatch = useDispatch();
  const { currentQuestion } = useSelector(({ quiz }) => quiz);

  const horizontalLines = Array.from({ length: rows - 1 });
  const verticalLines = Array.from({ length: cols - 1 });

  const handleSolved = () => {
    dispatch(setLastQuestionId(""));
    const ticketId = localStorage.getItem("Ticket");
    appApi
      .post(`/quizanswer/create`, {
        ticketId: ticketId,
        questionId: currentQuestion._id,
        rightAnswer: true,
      })
      .then(({ data }) => {
        dispatch(setQuestionAnswered(data.quizAnswer));
        // window.history.back();
      })
      .catch((error) => {
        errorHandler(error);
      });
  };

  return (
    <div className={classes.puzzleContainer}>
      {horizontalLines.map((_, index) => (
        <div
          key={`h-${index}`}
          className={`${classes.line} ${classes.horizontalLine}`}
          style={{ top: `${((index + 1) / rows) * 100}%` }}
        ></div>
      ))}
      {verticalLines.map((_, index) => (
        <div
          key={`v-${index}`}
          className={`${classes.line} ${classes.verticalLine}`}
          style={{ left: `${((index + 1) / cols) * 100}%` }}
        ></div>
      ))}
      <JigsawPuzzle
        imageSrc={imgSrc}
        rows={rows}
        columns={cols}
        onSolved={handleSolved}
      />
    </div>
  );
}
